import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { useHelpFlyout } from '../../../context/helpFlyoutContext';
import ProviderRequirementsChecklist from '../../../containers/ProviderRequirementsPage/ProviderRequirementsChecklist';

import css from './ProviderRequirementsHelpContent.module.css';

/**
 * HelpFlyout body: live provider requirements checklist.
 * Closes the flyout when the user navigates via an incomplete requirement link.
 */
const ProviderRequirementsHelpContent = () => {
  const { closeHelp } = useHelpFlyout();
  return (
    <>
      <h3 className={css.title}>
        <FormattedMessage id="HelpFlyout.requirementsContentTitle" />
      </h3>
      <ProviderRequirementsChecklist onRequirementNavigate={closeHelp} />
    </>
  );
};

export default ProviderRequirementsHelpContent;
